import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    attrs: {
      id: "logisticsInformation"
    }
  }, [_c("a-card", {
    staticStyle: {
      width: "1184px"
    },
    attrs: {
      bordered: false
    }
  }, [_c("a-form-model", {
    ref: "logisticsInformationForm",
    staticClass: "form",
    attrs: {
      model: _vm.logisticsInformationForm,
      rules: _vm.rules
    }
  }, [_c("a-row", {
    staticClass: "form-row",
    attrs: {
      gutter: 128
    }
  }, [_c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.choiceDays"),
      prop: "daysOfStock"
    }
  }, [_c("a-input-number", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: true,
      placeholder: _vm.$t("public.enterPlease"),
      max: 999
    },
    model: {
      value: _vm.logisticsInformationForm.daysOfStock,
      callback: function callback($$v) {
        _vm.$set(_vm.logisticsInformationForm, "daysOfStock", $$v);
      },
      expression: "logisticsInformationForm.daysOfStock"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.deliveryStatus")
    }
  }, [_c("a-select", {
    on: {
      change: _vm.changeDistribution
    },
    model: {
      value: _vm.logisticsInformationForm.distribution,
      callback: function callback($$v) {
        _vm.$set(_vm.logisticsInformationForm, "distribution", $$v);
      },
      expression: "logisticsInformationForm.distribution"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "0"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.yes")) + " ")]), _c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("public.no")) + " ")])], 1)], 1)], 1), _c("a-col", {
    attrs: {
      span: 8
    }
  }, [_vm.logisticsInformationForm.distribution == "0" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.expressWayPrimary"),
      prop: "transportFirstId"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.logisticsInformationForm.transportFirstId,
      callback: function callback($$v) {
        _vm.$set(_vm.logisticsInformationForm, "transportFirstId", $$v);
      },
      expression: "logisticsInformationForm.transportFirstId"
    }
  }, _vm._l(_vm.transportList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e(), _vm.logisticsInformationForm.distribution != "0" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("productDetail.expressWayPrimary")
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      disabled: true,
      placeholder: _vm.$t("public.pleaseSelect")
    },
    model: {
      value: _vm.logisticsInformationForm.transportFirstId,
      callback: function callback($$v) {
        _vm.$set(_vm.logisticsInformationForm, "transportFirstId", $$v);
      },
      expression: "logisticsInformationForm.transportFirstId"
    }
  }, _vm._l(_vm.transportList, function (item) {
    return _c("a-select-option", {
      key: item.id,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1) : _vm._e()], 1)], 1), _c("footer-tool-bar", [_c("a-button", {
    attrs: {
      loading: _vm.queryLoading,
      type: "primary"
    },
    on: {
      click: _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.$t("public.save")) + " ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };